import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {selectFeatures, selectUser} from '@components/Login/userSlice';
import {
    fetchEmailAliases,
    selectIsEmailAliasesLoading,
    selectEmailAliasesUserId
} from '@components/AccountSettings/EmailAliases/emailAliasesSlice';
import permissionsService from '@utils/permissionsService';
import type {AppDispatch} from '@src/client/index';

export default function useEmailAliasesLoader({isEnabled}: {isEnabled: boolean}) {
    const dispatch = useDispatch<AppDispatch>();
    const userId = useSelector(selectUser)?.id;
    const features = useSelector(selectFeatures);
    const aliasesUserId = useSelector(selectEmailAliasesUserId);
    const isLoadingAliases = useSelector(selectIsEmailAliasesLoading);

    const isAliasFeatureEnabled = Boolean(permissionsService.isEmailAliasEnabled({features}));

    useEffect(() => {
        if (isEnabled && userId && isAliasFeatureEnabled && aliasesUserId !== userId && !isLoadingAliases) {
            dispatch(fetchEmailAliases());
        }
    }, [dispatch, isEnabled, userId, isAliasFeatureEnabled, aliasesUserId, isLoadingAliases]);
}
